<template>
    <div class="d-flex">
        <div class="side d-flex" v-show="isMenuOpen">
            <SidebarComponent />
            <DatabarComponent :key="$route.params.chatId" @menuClose="isMenuOpen = false" />
        </div>
        <NavbarComponent @deleteChat="chatDelete" :chatId="chatId" @menuOpen="isMenuOpen = true" />

        <div class="wrapper">
            <div class="content">
                <div class="messages" v-if="messages.length > 0">
                    <div v-for="(message, index) in messages" :key="index" :class="['message', message.sender]">
                        <div class="message-wrapper" v-html="formatMessage(message.text)"></div>
                    </div>

                    <IconInnerShadowBottomRightFilled v-show="thinking" class="thinking" />
                </div>
                <div class="welcome" v-else>
                    Добро пожаловать, я <strong>Гего</strong> 😎 <br> <code style="font-size: 14px;">{{ chatId }}</code>
                </div>
            </div>
            <div class="input-wrapper">
                <div class="attachment-button">
                    <IconPaperclip class="icon" @click="attachFile" />
                </div>

                <input type="text" v-model="newMessage" @keyup.enter="sendMessage"
                    placeholder="Готовы планировать свое будущее путешествие?">

                <div class="send-button" @click="sendMessage">
                    <IconSend class="icon" />
                </div>
            </div>

            <input type="file" id="fileInput" style="display: none;" ref="fileInput" @change="uploadFile" />
        </div>
    </div>
</template>

<script>
import SidebarComponent from "@/components/SidebarComponent.vue";
import DatabarComponent from "@/components/DatabarComponent.vue";
import NavbarComponent from "@/components/NavbarComponent.vue";
import { IconPaperclip, IconSend, IconInnerShadowBottomRightFilled } from '@tabler/icons-vue';
import { marked } from 'marked';

export default {
    name: "ChatView",
    components: {
        SidebarComponent,
        DatabarComponent,
        NavbarComponent,
        IconInnerShadowBottomRightFilled,
        IconPaperclip,
        IconSend
    },
    data() {
        return {
            messages: [],
            newMessage: "",
            isMenuOpen: window.innerWidth > 810,
            newChatId: null,
            thinking: false,
            attachedFiles: new FormData()
        };
    },
    _methods: {
        scrollToBottom() {
            this.$nextTick(() => {
                var container = this.$el.querySelector(".messages");

                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },

        uploadFile() {
            this.thinking = true;
            // Array.from(value.target.files).forEach(element => {
            //     this.attachedFiles.append('files[]', element);
            // });

            // console.log(this.attachedFiles);
            alert('Comming soon...');
            this.thinking = false;
        },

        attachFile() {
            this.$refs.fileInput.click();
        },

        formatMessage(message) {
            // I want to create markdown general 

            return marked(message);
        },

        async chatDelete() {
            if (!this.chatId) return;

            if (confirm('Are you sure?')) {
                try {
                    await this.$api.deleteChat(this.chatId);
                    this.messages = [];
                    this.$router.push("/");
                    this.$nextTick(() => {
                        this.$forceUpdate();
                    });

                } catch (error) {
                    this.$snackbar.add({
                        type: 'error',
                        text: 'Failed to delete chat 😢'
                    });
                }
            }
        },

        async createChat() {
            const chatId = await this.$api.createChat(this.newMessage);
            this.newChatId = chatId;

            return this.newChatId;
        },

        _sendMessage: async function () {
            let chatId = this.chatId;

            if (this.thinking) return;

            if (!chatId) {
                try {
                    chatId = await this.createChat();

                } catch (error) {
                    this.$snackbar.add({
                        type: 'error',
                        text: 'Failed to create chat 😢'
                    });
                    return;
                }
            }

            if (this.newMessage.trim() !== "") {
                this.thinking = true;
                this.messages.push({ sender: "user", text: this.newMessage });
                let msg = this.newMessage;
                this.newMessage = "";

                this.$nextTick(() => this.scrollToBottom());

                try {
                    const response = await this.$api.respond(msg, chatId);

                    if (response.success) {
                        this.messages.push({ sender: "ai", text: response.answer });
                        this.$nextTick(() => this.scrollToBottom());
                    }
                } catch (error) {
                    this.$api.handleError(error);
                    this.newMessage = "";
                    this.$snackbar.add({
                        type: 'error',
                        text: 'Failed to send message'
                    });
                }

                this.thinking = false;

                if (this.$route.params.chatId !== chatId) {
                    this.$router.push(`/chat/${chatId}`);
                }
            }
        },
        get sendMessage() {
            return this._sendMessage;
        },
        set sendMessage(value) {
            this._sendMessage = value;
        },

        loadChat() {
            if (this.chatId !== undefined) {
                return this.$api.getChatHistory(this.chatId).then((history) => {
                    this.messages = history;
                    this.$nextTick(() => this.scrollToBottom());
                });
            }
        },

        onResize() {
            this.isMenuOpen = window.innerWidth > 810
        }

    },
    get methods() {
        return this._methods;
    },
    set methods(value) {
        this._methods = value;
    },

    mounted() {
        // this.scrollToBottom();
        // this.loadChat();
        // this.$nextTick(() => {
        //     window.addEventListener('resize', this.onResize);
        // })

        console.log(this.$api.isAuthenticated())
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
    },


    computed: {
        chatId() {
            return this.$route.params.chatId;
        }
    },

    watch: {
        chatId() {
            this.messages = [];
            this.loadChat();

            console.log(this.chatId)
        },
    }
};
</script>


<style scoped>
.wrapper {
    max-width: 720px;
    margin: 0px auto;
    position: relative;
    width: 100%;
}

.input-wrapper {
    position: absolute;
    width: calc(100% - 40px);
    bottom: 30px;
    color: var(--color-text-secondary);
    border: 1px solid var(--color-border);
    border-radius: var(--default-border-radius);
    display: flex;
    margin: 0px 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    background-color: var(--background-color);
}

.input-wrapper input {
    width: 100%;
    border: none;
    font-size: 14px;
    padding: 14px;
    color: var(--color-text-secondary);
    background-color: transparent;
}

.input-wrapper input:focus {
    outline: none;
}

/* 
.content {
    height: calc(100% - 130px);
    margin: 67px 11px;
} */

.attachment-button:hover {
    background-color: var(--color-hover);
}

.attachment-button,
.send-button {
    width: 40px;
    height: 40px;
    padding: 8px;
    cursor: pointer;
    margin: 6px;
    border-radius: var(--default-border-radius);
}

.send-button {
    background-color: var(--color-primary);
}

.send-button .icon {
    color: #000
}

.icon {
    width: 24px;
    height: 24px;
}

.messages {
    height: calc(100vh - 100px);
    overflow-y: auto;
    padding: 90px 10px;
    -ms-overflow-style: none;
    /* Internet Explorer 10+ */
    scrollbar-width: none;
    /* Firefox */
}

.messages::-webkit-scrollbar {
    display: none;
}

.message {
    margin-bottom: 10px;
    font-size: 16px;
    color: var(--color-text-secondary);
}

.message.user {
    text-align: left;
    justify-content: right;
    display: flex;
}

.message.ai {
    text-align: left;
    justify-content: left;
    display: flex;
}

.message.user .message-wrapper {
    background-color: var(--color-hover);
    border-radius: var(--default-border-radius);
    border-top-right-radius: 0px;
    padding: 16px 21px;
    max-width: 80%;
    margin-top: 10px;
}

.message.ai .message-wrapper {
    background-color: var(--color-primary);
    border-radius: var(--default-border-radius);
    border-bottom-left-radius: 0px;
    padding: 20px 20px 13px 20px;
    margin-top: 10px;
    color: #000;
    max-width: 80%;
}

.welcome {
    text-align: center;
    padding: 20px;
    font-size: 24px;
    color: var(--color-text-secondary);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
}

.thinking {
    -webkit-animation: spin 1s linear infinite;
    -moz-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
}

.message.user .message-wrapper,
.message.ai .message-wrapper {
    max-width: 90%;
}

.message-wrapper p {
    font-size: 12px;
}

@-moz-keyframes spin {
    100% {
        -moz-transform: rotate(360deg);
    }
}

@-webkit-keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@media only screen and (max-width: 810px) {
    .side {
        position: fixed;
        z-index: 99999;
        width: 100%;
    }

    .messages {
        width: 100%;
        padding: 80px 17px;
    }

    .wrapper {
        height: calc(100vh - 30px);
    }
}
</style>